import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../context/LangContext";
import { LogoMark } from "../components/icons";

const LegalPage = ({ type }) => {
  const { t } = useLang();
  const doc = t.legal[type];

  return (
    <div className="relative min-h-screen overflow-hidden">
      <div className="bg-grid pointer-events-none absolute inset-0" />
      <div className="pointer-events-none absolute -top-24 left-1/2 h-[300px] w-[540px] -translate-x-1/2 rounded-full bg-blue-600/15 blur-[120px]" />

      <header className="glass relative">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4 sm:px-8">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-2.5">
            <LogoMark className="h-8 w-8" />
            <span className="font-display text-base font-extrabold tracking-wide text-white">MB PAY VIA</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold text-slate-300 transition-colors hover:text-white"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            {t.nav.cta === "申请专属费率" ? "返回首页" : "Back Home"}
          </Link>
        </div>
      </header>

      <main className="relative mx-auto max-w-3xl px-5 pb-24 pt-14 sm:px-8">
        <h1 className="font-display text-3xl font-black text-white sm:text-4xl">{doc.title}</h1>
        <div className="mt-4 h-1 w-16 rounded-full bg-gradient-to-r from-blue-500 to-violet-500" />
        <p className="mt-8 text-sm leading-relaxed text-slate-400">{doc.intro}</p>

        <div className="mt-10 space-y-9">
          {doc.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="flex items-center gap-3 font-display text-base font-extrabold text-white">
                <span className="text-gradient font-display text-sm font-black">{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.p}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
